import { render } from "./Team_index_m.vue?vue&type=template&id=d0bcef82&scoped=true"
import script from "./Team_index_m.vue?vue&type=script&lang=js"
export * from "./Team_index_m.vue?vue&type=script&lang=js"

import "./Team_index_m.vue?vue&type=style&index=0&id=d0bcef82&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d0bcef82"

export default script